import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function (props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 24 24">
      <path d="M19 15H21V17H19V15Z"/>
      <path d="M15 19H17V21H15V19Z"/>
      <path d="M11 19C11 20.1046 11.8954 21 13 21V19H11Z"/>
      <path d="M11 15H13V17H11V15Z"/>
      <path d="M11 13C11 11.8954 11.8954 11 13 11V13H11Z"/>
      <path d="M15 11H17V13H15V11Z"/>
      <path d="M21 13C21 11.8954 20.1046 11 19 11V13H21Z"/>
      <path d="M21 19C21 20.1046 20.1046 21 19 21V19H21Z"/>
      <path d="M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V8C21 8.55228 20.5523 9 20 9H10C9.44772 9 9 9.44772 9 10V20C9 20.5523 8.55228 21 8 21H4C3.44772 21 3 20.5523 3 20V4Z"/>
    </CommonSVGIcon>
  );
}
